<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <CharacterForm :baseCharacter="character" :loading="loading" @submit-requested="submitRequested"></CharacterForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import CharacterForm from './CharacterForm.vue'
import router from '@/router';

export default {
    data() {
        return {
            character: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { CharacterForm },
    computed:
    {
        ...mapState('characters', ['getCharacterByIdOutput']),
    },
    methods: {
        ...mapActions('characters', ['getCharacterById']),
        ...mapActions('characters', ['putCharacter']),
        submitRequested(characters) {
            this.putCharacter(characters);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'CharactersList' });
        }

        this.getCharacterById(this.$route.query.id);
    },
    watch:
    {
        getCharacterByIdOutput: function(characterOutput)
        {
            if(!characterOutput && !characterOutput.data)
            {
                router.push({ name: 'CharactersList' });
            }
            else
            {
                this.character = characterOutput.data;
                // console.log(this.character);
                this.loading = false;
            }
        }
    }
}
</script>